import { IonButton, IonBadge, IonIcon } from '@ionic/react';
import {
  personCircleOutline,
  lockClosed,
  lockOpen,
  notifications,
} from 'ionicons/icons';
import type { FantasyLeagueCardData } from './types';
import { LeagueImage } from '../../../components/LeagueImage';

interface FantasyLeagueCardProps {
  league: FantasyLeagueCardData;
  onAction: () => void;
  actionLabel?: string;
}

export const FantasyLeagueCard = ({
  league,
  onAction,
  actionLabel = 'Entrar',
}: FantasyLeagueCardProps) => {
  const showNotifications = league.unreadActivityCount !== undefined;

  return (
    <div className="bg-white rounded-2xl shadow-md p-4 mx-4 my-3">
      {/* Top row: league image (or shield) + league info */}
      <div className="flex items-center gap-3">
        <LeagueImage image={league.image} updatedAt={league.updatedAt} name={league.name} size={48} />

        <div className="flex-1 min-w-0 flex items-center justify-between gap-2">
          {/* Left: name, creator, participants */}
          <div className="min-w-0">
            <p className="font-bold text-base leading-tight truncate">{league.name}</p>
            <div className="flex items-center gap-1 mt-0.5">
              <IonIcon icon={personCircleOutline} style={{ fontSize: '1rem', color: 'var(--ion-color-medium)', flexShrink: 0 }} />
              <span className="text-sm text-gray-500 truncate">
                {league.creator?.fullName ?? 'Desconocido'}
              </span>
            </div>
            <span className="text-sm text-gray-500">
              {league.participantsCount}{' '}
              {league.participantsCount === 1 ? 'participante' : 'participantes'}
            </span>
          </div>

          {/* Right: icons, vertically centered against the two text lines */}
          <div className="flex items-center gap-2 shrink-0">
            <IonIcon
              icon={league.isPublic ? lockOpen : lockClosed}
              color={league.isPublic ? 'success' : 'warning'}
              style={{ fontSize: '1.3rem' }}
            />

            {showNotifications && (
              <div className="relative flex items-center">
                <IonIcon
                  icon={notifications}
                  style={{ color: '#C8A951', fontSize: '1.3rem' }}
                />
                {league.unreadActivityCount! > 0 && (
                  <IonBadge
                    color="danger"
                    style={{ position: 'absolute', top: '-6px', right: '-8px', fontSize: '0.6rem', padding: '2px 4px' }}
                  >
                    {league.unreadActivityCount}
                  </IonBadge>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <hr className="mt-3 mb-1 border-gray-200" />

      <IonButton expand="block" fill="solid" color="primary" onClick={onAction}>
        {actionLabel}
      </IonButton>
    </div>
  );
};
